import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useLang } from "../context";
import { COLLECTIONS, t } from "../content";
import { http } from "../api";
import { ProductCard } from "../components/ProductCard";

export default function Shop() {
  const { lang } = useLang();
  const [params, setParams] = useSearchParams();
  const active = params.get("c") || "all";
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const url = active === "all" ? "/products" : `/products?collection=${active}`;
    http.get(url).then((r) => setProducts(r.data));
  }, [active]);

  const tabs = [{ slug: "all", fr: "Tout", en: "All" }, ...COLLECTIONS];

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-12">
      <h1 className="serif text-5xl lg:text-6xl">{t.nav.shop[lang]}</h1>
      <div className="mt-8 flex flex-wrap gap-2 border-b border-[#1A1A1A]/10 pb-4">
        {tabs.map((c) => (
          <button key={c.slug} data-testid={`filter-${c.slug}`}
            onClick={() => setParams(c.slug === "all" ? {} : { c: c.slug })}
            className={`px-4 py-2 text-xs uppercase tracking-widest rounded-sm transition-colors ${active === c.slug ? "bg-[#1A1A1A] text-[#F9F8F6]" : "text-[#737373] hover:text-[#1A1A1A]"}`}>
            {c[lang]}
          </button>
        ))}
      </div>
      <div className="mt-12 grid grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-14">
        {products.map((p, i) => <ProductCard key={p.id} p={p} index={i} />)}
      </div>
      {products.length === 0 && <p className="text-sm text-[#737373] py-20 text-center">…</p>}
    </div>
  );
}
